import { Building2, Mail } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";

export const NoFacilityScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-screen bg-neutral-50">
      <div className="w-full max-w-lg p-8 mx-4 text-center bg-white border shadow-sm rounded-2xl border-neutral-200">
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 rounded-full bg-primary-50">
          <Building2 className="w-10 h-10 text-primary-500" />
        </div>

        <h1 className="mb-3 text-2xl font-bold text-neutral-900">
          {t("noFacility.title")}
        </h1>
        <p className="mb-8 leading-relaxed text-neutral-500">
          {t("noFacility.description")}
        </p>

        <div className="p-4 mb-6 space-y-3 text-left border bg-neutral-50 rounded-xl border-neutral-100">
          <p className="text-sm font-medium text-neutral-700">
            {t("noFacility.contactLabel")}
          </p>
          <a
            href="mailto:con"
            className="flex items-center gap-3 text-sm transition-colors text-primary-600 hover:text-primary-700"
          >
            <Mail className="flex-shrink-0 w-4 h-4" />
            contact@medecine360.com
          </a>
          {/* TODO: add phoneNumber */}
        </div>

        <p className="text-xs text-neutral-400">
          {t("noFacility.hint")}
        </p>
      </div>
    </div>
  );
};
